<template>
  <div>
    <meta
      v-if="shippingWeight"
      :itemprop="SCHEMA_ITEM_PROP.WEIGHT"
      :content="shippingWeight"
    >
    <meta
      v-if="shippingHeight"
      :itemprop="SCHEMA_ITEM_PROP.HEIGHT"
      :content="shippingHeight"
    >
    <meta
      v-if="shippingWidth"
      :itemprop="SCHEMA_ITEM_PROP.WIDTH"
      :content="shippingWidth"
    >
    <meta
      v-if="shippingDepth"
      :itemprop="SCHEMA_ITEM_PROP.DEPTH"
      :content="shippingDepth"
    >
    <meta
      v-if="releaseDate"
      :itemprop="SCHEMA_ITEM_PROP.RELEASE_DATE"
      :content="releaseDate"
    >
    <meta
      v-if="brand"
      :itemprop="SCHEMA_ITEM_PROP.BRAND"
      :content="brand"
    >
  </div>
</template>
<script lang="ts">

import type { ProductVariant } from '~~/types/commercetools';
import {
  getProductAttributesExtended,
} from '~~/helpers/product/getProductAttributesExtended';

import type { ProductProcessedAttributes } from '~~/types/product/attribute/ProductProcessedAttributes';
import { SCHEMA_ITEM_PROP, SCHEMA_ITEM_TYPE } from '~~/constants/seo';
import { PRODUCT_ATTRIBUTES } from '~~/constants/products';

export default defineComponent({
  name: 'ProductDetailsMetaSchema',
  props: {
    product: {
      type: Object as PropType<ProductVariant>,
      required: true,
    },
    attributesLocalized: {
      type: Object as PropType<ProductProcessedAttributes>,
      required: true,
    },
  },
  setup(props) {

    const { shippingHeight, shippingWidth, shippingDepth, shippingWeight } = useProductDetails(props.product);

    const brand = computed(() => props.attributesLocalized?.brand);
    const releaseDate = computed(() =>
      getProductAttributesExtended(
        props.product,
        {
          attributeNames: [PRODUCT_ATTRIBUTES.RELEASE_DATE],
        },
      )[PRODUCT_ATTRIBUTES.RELEASE_DATE],
    );

    return {
      shippingHeight,
      shippingWidth,
      shippingDepth,
      shippingWeight,
      brand,
      releaseDate,
      SCHEMA_ITEM_TYPE,
      SCHEMA_ITEM_PROP,
    };
  
  },
});

</script>
